import { Link } from "react-router-dom";
import React, { useState } from "react";

export default function Schedule() {

    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        monthlyMembership: false,
        dropInPass: false,
        questions: '',
        instagram: false,
        facebook: false
    });

    const fullNameRegex = /^[A-Za-zА-Яа-яЁё]{2,} [A-Za-zА-Яа-яЁё]{2,}$/;

    const [errors, setErrors] = useState<{ fullName?: string }>({});

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {

        const { name, value, type } = e.target;

        if (type === 'checkbox') {

            const checkbox = e.target as HTMLInputElement;

            setFormData(prev => ({
                ...prev,
                [name]: checkbox.checked
            }));

        } else {

            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }

        if (name === 'fullName') {

            if (!fullNameRegex.test(value.trim())) {

                setErrors(prev => ({
                    ...prev,
                    fullName: 'Please enter your first and last name'
                }));

            } else {

                setErrors(prev => ({
                    ...prev,
                    fullName: undefined
                }));
            }
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {

        e.preventDefault();

        if (
            !formData.fullName ||
            !formData.email ||
            !fullNameRegex.test(formData.fullName.trim())
        ) {
            setSubmitStatus('error');
            return;
        }

        setIsSubmitting(true);

        try {

            const response = await fetch('/api/presale', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },

                body: JSON.stringify({
                    fullName: formData.fullName,
                    email: formData.email,
                    phone: formData.phone,
                    monthlyMembership: formData.monthlyMembership,
                    dropInPass: formData.dropInPass,
                    questions: formData.questions
                })
            });

            if (!response.ok) {
                throw new Error('Request failed');
            }

            setSubmitStatus('success');

            setFormData({
                fullName: '',
                email: '',
                phone: '',
                monthlyMembership: false,
                dropInPass: false,
                questions: '',
                instagram: false,
                facebook: false
            });

        } catch (error) {

            console.error(error);

            setSubmitStatus('error');

        } finally {

            setIsSubmitting(false);
        }
    };

    return (

        <main className="bg-[#FBF7F7]">

            <div className="flex-grow justify-items-center sm:flex-row md:px-8 sm:px-0 justify-center gap-4 lg:gap-16 md:gap-8 pt-6">

                <Link to="/buy-now?_mt=%2Fbuy%2F48717%3FactiveProduct%3Dmemberships-14788">

                    <picture className="block cursor-pointer m-auto mb-4 overflow-hidden max-w-[768px]">

                        <source
                            media="(max-width: 768px)"
                            srcSet="/img/presa;e_banner_3_mobile.png"
                        />

                        <img
                            src="/img/Presale_Banner_3.jpg"
                            alt="Presale banner"
                            className="w-full max-w-[768px] md:max-w-[1250px] h-auto max-h-[500px] m-auto object-contain md:max-h-none md:rounded-3xl"
                        />
                    </picture>

                </Link>

            </div>

            <section className="py-12">

                <div className="max-w-7xl mx-auto px-6">

                    <h3 className="text-[#00889D] text-2xl font-bold mb-4">
                        Yoga 7 Studio in Langley, across the Willowbrook Mall
                    </h3>

                    <h3 className="text-[#6C6C6C] text-2xl font-bold mb-4">
                        Hot Yoga & Fitness Fusion
                    </h3>

                    <div className="text-[#6C6C6C]">
                        Feel the intensity of <b className="text-[#00889D]">Hot Yoga</b> and the
                        creativity of <b className="text-[#00889D]">Fitness Fusion</b>
                        in <b className="text-[#00889D]">Far Infrared (FIR)</b> heat.
                        From traditional yoga to dynamic flow, power, sculpt, cardio,
                        pilates fusion, and sound baths—every class blends energy with restoration
                    </div>

                    <div className="grid lg:grid-cols-2 gap-12 text-[#6C6C6C]">

                        {/* Left Column */}
                        <div>

                            <h3 className="text-[#00889D] text-2xl font-bold mt-4">
                                Opening Soon Presale
                            </h3>

                            <div className="mt-5">
                                Expected Opening Date: <b>April, 2026.</b>
                            </div>

                            <div className="mt-5">
                                <b className="text-[#02BFA7]">
                                    $99 - Unlimited Monthly Autopay Membership
                                </b>{" "}
                                for 3 months, followed by a lifelong discount:
                            </div>

                            <div className="mt-5">
                                <b>Tier 1:</b>{" "}
                                <b className="text-[#02BFA7]">20 % off</b> — limited to
                                90 memberships.
                            </div>

                            <div>
                                <b>Tier 2:</b>{" "}
                                <b className="text-[#02BFA7]">15 % off</b> — limited to
                                70 memberships.
                            </div>

                            <div>
                                <b>Tier 3:</b>{" "}
                                <b className="text-[#02BFA7]">10 % off</b> — limited to
                                30 memberships.
                            </div>

                            <div className="mt-5">
                                Regular Unlimited Monthly Autopay rate is $179*
                            </div>

                            <div className="text-xs">
                                *Rates are subject to change with advanced notice
                            </div>

                            <div className="mt-5">
                                <b className="text-[#02BFA7]">$19 -</b> The{" "}
                                <b className="text-[#02BFA7]">
                                    2 weeks Membership
                                </b>{" "}
                                introductory offer
                            </div>

                            <div className="my-4">
                                <b className="text-[#02BFA7]">
                                    Follow us on Facebook and Instagram to see updates
                                </b>
                                , open house and opening date announcements
                            </div>

                            <div className="flex space-x-3 py-4">

                                <a
                                    href="https://www.instagram.com/yogasevenstudio?igsh=MWtsY3lhd2piZW5hcg%3D%3D&utm_source=qr"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-8 h-8 bg-[#14B6A4] rounded-full flex items-center justify-center hover:bg-[#12a08f] transition-colors"
                                >
                                    <i className="ri-instagram-line text-white text-sm"></i>
                                </a>

                                <a
                                    href="https://www.facebook.com/profile.php?id=61585312964707"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-8 h-8 bg-[#14B6A4] rounded-full flex items-center justify-center hover:bg-[#12a08f] transition-colors"
                                >
                                    <i className="ri-facebook-fill text-white text-sm"></i>
                                </a>

                            </div>

                            <div>

                                <h3 className="text-[#00889D] font-semibold mt-6 mb-2">
                                    Studio Location
                                </h3>

                                <p className="text-gray-700">
                                    105-19925 Willowbrook Dr., Langley
                                </p>

                                <p className="text-gray-700">
                                    Located near Willowbrook Shopping Centre
                                </p>

                            </div>

                            <div>

                                <h3 className="text-[#00889D] font-semibold mt-6 mb-2">
                                    Phone
                                </h3>

                                <p className="text-gray-700">
                                    (778) 237-7790
                                </p>

                            </div>

                            <div>

                                <h3 className="text-[#00889D] font-semibold mt-6 mb-2">
                                    Email
                                </h3>

                                <p className="text-gray-700">
                                    info@yogaseven.com
                                </p>

                            </div>

                        </div>

                        {/* Right Column */}
                        <div>

                            <div className="bg-white py-4 px-8 rounded-2xl overflow-hidden">

                                <h3 className="text-[#00889D] text-2xl font-bold mb-6">
                                    Register for Presale Special Offer
                                </h3>

                                <form
                                    onSubmit={handleSubmit}
                                    className="space-y-6 pb-8"
                                    data-readdy-form
                                    id="presale-registration"
                                >

                                    {/* Full Name and Email */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                        <div>

                                            <label
                                                htmlFor="fullName"
                                                className="block text-[#00889D] font-semibold mb-2"
                                            >
                                                Full name *
                                            </label>

                                            <input
                                                type="text"
                                                id="fullName"
                                                name="fullName"
                                                value={formData.fullName}
                                                onChange={handleInputChange}
                                                required
                                                className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition-colors ${
                                                    errors.fullName
                                                        ? 'border-red-500'
                                                        : 'border-gray-200 focus:border-[#00889D]'
                                                }`}
                                            />

                                            {errors.fullName && (
                                                <p className="mt-1 text-sm text-red-500">
                                                    {errors.fullName}
                                                </p>
                                            )}

                                        </div>

                                        <div>

                                            <label
                                                htmlFor="email"
                                                className="block text-[#00889D] font-semibold mb-2"
                                            >
                                                Email Address *
                                            </label>

                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                required
                                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#00889D] focus:outline-none transition-colors"
                                            />

                                        </div>

                                    </div>

                                    {/* Phone Number */}
                                    <div>

                                        <label
                                            htmlFor="phone"
                                            className="block text-[#00889D] font-semibold mb-2"
                                        >
                                            Phone Number *
                                        </label>

                                        <input
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            required
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#00889D] focus:outline-none transition-colors"
                                        />

                                    </div>

                                    {/* Membership Interest */}
                                    <div>

                                        <label className="block text-[#00889D] font-semibold mb-4">
                                            I'm interested to reserve promo price
                                        </label>

                                        <div className="grid gap-3">

                                            <label className="flex items-start space-x-3 cursor-pointer">

                                                <input
                                                    type="radio"
                                                    name="promo"
                                                    checked={formData.monthlyMembership}
                                                    onChange={() =>
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            monthlyMembership: true,
                                                            dropInPass: false
                                                        }))
                                                    }
                                                    className="mt-1 w-5 h-5 text-[#00889D] border-2 border-gray-300 focus:ring-[#00889D]"
                                                />

                                                <span className="text-gray-700">
                                                    $99 Monthly Membership for 3 Months & lifelong discount
                                                </span>

                                            </label>

                                            <label className="flex items-start space-x-3 cursor-pointer">

                                                <input
                                                    type="radio"
                                                    name="promo"
                                                    checked={formData.dropInPass}
                                                    onChange={() =>
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            dropInPass: true,
                                                            monthlyMembership: false
                                                        }))
                                                    }
                                                    className="mt-1 w-5 h-5 text-[#00889D] border-2 border-gray-300 focus:ring-[#00889D]"
                                                />

                                                <span className="text-gray-700">
                                                    $19 One-time 2 Weeks Drop-In
                                                </span>

                                            </label>

                                        </div>

                                    </div>

                                    {/* Questions */}
                                    <div>

                                        <label
                                            htmlFor="questions"
                                            className="block text-[#00889D] font-semibold mb-2"
                                        >
                                            Any questions?
                                        </label>

                                        <textarea
                                            id="questions"
                                            name="questions"
                                            value={formData.questions}
                                            onChange={handleInputChange}
                                            maxLength={500}
                                            rows={4}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#00889D] focus:outline-none transition-colors resize-none"
                                            placeholder="Share any questions or special requests..."
                                        />

                                        <div className="text-right text-sm text-gray-500 mt-1">
                                            {formData.questions.length}/500 characters
                                        </div>

                                    </div>

                                    {/* Submit Button */}
                                    <div className="pt-6">

                                        <button
                                            type="submit"
                                            disabled={isSubmitting}
                                            className="w-full bg-[#00889D] hover:bg-[#007089] text-white font-bold py-4 px-8 rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                                        >
                                            {isSubmitting ? 'Submitting...' : 'Submit'}
                                        </button>

                                    </div>

                                    {/* Status Messages */}
                                    {submitStatus === 'success' && (

                                        <div className="mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                                            Thank you! Your presale registration has been submitted successfully.
                                        </div>

                                    )}

                                    {submitStatus === 'error' && (

                                        <div className="mt-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                                            Please fill in all required fields and try again.
                                        </div>

                                    )}

                                </form>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

        </main>
    );
}